var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 368.095,
    height: 328.75,
    viewBox: "0 0 368.095 328.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(-249.361 -185.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 153,
    cy: 153,
    r: 153,
    transform: "translate(268.948 185.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(-184.92 149.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Model_2",
    "data-name": "Model 2",
    transform: "translate(616.307 62.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 82.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M564.059,127.4c9.259,6.682,34.005,15.77,40.57,11.41s6.822-25.472,6.822-25.472L592.233,111.9s.32,9.567-2.171,10.581-22.971-4.557-22.971-4.557l-.823-.311-3.612-1.506c-.1-.043-.062-.456-.063-.547a1.47,1.47,0,0,0-.125-.691,15.981,15.981,0,0,0-.922-1.74,6.789,6.789,0,0,1-1.3-3.183,3.519,3.519,0,0,1,.393-1.671,6.443,6.443,0,0,0,.513-1.07,1.252,1.252,0,0,0-.195-1.171,1.117,1.117,0,0,0-.658-.325,2.036,2.036,0,0,0-1.935.972,5.215,5.215,0,0,0-.71,2.251,9.367,9.367,0,0,1-.382,1.886,1.915,1.915,0,0,1-1.639,1.463l-1.568-.655-.962-.4a1.377,1.377,0,0,0-1.809.953,1.675,1.675,0,0,0,.815,2.048l-.314-.132a1.341,1.341,0,0,0-1.759.973,1.675,1.675,0,0,0,.815,2.048l.167.07a1.341,1.341,0,0,0-1.759.973,1.672,1.672,0,0,0,.815,2.048l.051.021.361.151a.945.945,0,0,0-1.241.688,1.18,1.18,0,0,0,.575,1.444l.745.312q3.176,1.324,6.351,2.656c.517.217,1.312.759,1.881.572a2.594,2.594,0,0,0,.495-.295c.727-.444,1.621.2,2.323.5l1.726.72Z",
    transform: "translate(-549.172 -105.687)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M594.745,84.686l-5.786-11.579-7.007,5.79,1.094,10.421,5.3,16.9,9.792-5.06Z",
    transform: "translate(-529.998 -41.796)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M644.077,145.008s-9.047,61.546-9.221,66.762-4,59.385-4,59.385l-34.921,2.007s-7.644-41.529-7.47-57.379,5.138-74.249,5.138-74.249l28.211,4.23Z",
    transform: "translate(-526.187 -1.769)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M598.411,80.638s29.747-7.719,41.78,31.649,11.364,62.912,11.364,68.7-50.47-3.474-50.47-3.474,3.677-20.077,2.007-27.792-7.354-24.7-7.354-24.7v6.435l-19.051-4.119S571,95.69,586.713,85.269C586.713,85.269,597.074,106.112,598.411,80.638Z",
    transform: "translate(-533.664 -37.749)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M618.6,110.459l-3.967,58.3s-.637,3.173-8.746,2.661c-13.185-.832-20.3-3.053-4.712-3.6l1.793-.529a2.273,2.273,0,0,0,1.4-2.52l-7.006-56.078Z",
    transform: "translate(-523.943 -20.982)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M603.292,160.508s-6.332,37.507-3.983,59.221,3.861,41.293,3.861,41.293",
    transform: "translate(-520.15 9.331)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M615.513,95.255s2.339,16.725,2.339,23.673L596.1,116.547l-1.642-19.363",
    transform: "translate(-522.683 -28.84)",
    fill: "#073aaa",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M605.834,223.41s1.086,8.575.553,9.068a20.95,20.95,0,0,0-1.854,3.176l1.279,4.221,7.354.972,5.571-6.915v-9.946Z",
    transform: "translate(-516.789 46.126)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M608.124,224.6V236.2l-4.273,7.757-.143.312-7.995-1.135-1.39-5.9s1.745-1.766,2.642-2.526c.093-.079-1.281-.147-1.225-.2.3-.3.647-3.084.211-5.725a20.179,20.179,0,0,1-.151-4.856Z",
    transform: "translate(-522.761 46.427)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M590.879,222.082l.376,4.329a1.276,1.276,0,0,0,1.284,1.167l23.424-.225a1.276,1.276,0,0,0,1.265-1.249l.111-5.029a1.277,1.277,0,0,0-1.327-1.3L592.1,220.7A1.278,1.278,0,0,0,590.879,222.082Z",
    transform: "translate(-524.779 43.997)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M600.137,222,600.5,227a1.267,1.267,0,0,0,.3.742,1.28,1.28,0,0,0,1,.444l26.336-.659a1.278,1.278,0,0,0,1.244-1.228l.22-5.793a1.276,1.276,0,0,0-1.344-1.323L601.884,220.6l-.542.028A1.277,1.277,0,0,0,600.137,222Z",
    transform: "translate(-519.362 43.652)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M602.6,220.03l-1.233.044a1.348,1.348,0,0,0-1.23,1.425l.36,5.005a1.267,1.267,0,0,0,.3.742",
    transform: "translate(-519.362 44.149)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M603.167,228.075c1.335,2.178,7.443,5.5,12.453,2.179.265-.214.6-.027.664.395.39,2.419.94,5.628,1.381,8.166a45.253,45.253,0,0,1,.653,8.524h0l-36.4-.637h0c.049-2.786,1.5-5.119,3.428-5.563,4.742-1.092,12.848-3.441,17.034-12.948C602.561,227.788,602.95,227.72,603.167,228.075Z",
    transform: "translate(-530.015 48.72)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M613.746,228.689c1.415,2.311,7.785,5.39,12.917,2.037.282-.227.634-.03.705.417.414,2.568,1,5.972,1.464,8.663a47.908,47.908,0,0,1,.693,9.041h0l-38.606-.675h0a8.4,8.4,0,0,1,.173-1.569c.461-2.227,1.794-3.948,3.463-4.332,4.4-1.013,12.41-3.59,16.74-10.3a17.756,17.756,0,0,0,1.62-3.162C613.1,228.385,613.516,228.313,613.746,228.689Z",
    transform: "translate(-524.752 49.071)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M591.028,245.3c.461-2.227,1.794-3.948,3.463-4.332,4.4-1.013,12.41-3.59,16.74-10.3",
    transform: "translate(-524.689 50.374)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 4.768,
    y1: 14.283,
    transform: "translate(57.305 72.993)",
    fill: "#9bcaa7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M594.572,67.562a61.526,61.526,0,0,1,3.1,12.574,12.181,12.181,0,0,1-2.352,8.939l-.352.468a8.769,8.769,0,0,1-8.8,3.317h0a12.16,12.16,0,0,1-8-5.681,89.888,89.888,0,0,1-5.574-11.624s-5.508-11.97,6.432-16.04S594.572,67.562,594.572,67.562Z",
    transform: "translate(-536.214 -50.235)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M598.857,77.223l.044.124a2.418,2.418,0,0,0,3.124,1.484l.017-.008.162-2.084a22.4,22.4,0,0,0,.141-2.9c.075-3.88.582-5.636-.382-8.321-2.55-7.105-6.578-5.145-6.578-5.145A4.282,4.282,0,0,0,595,59.8c-7-10.179-15.312-6.348-20.476-1.813a14.328,14.328,0,0,0-2.043,1.983c-.477.512-.905,1.008-1.276,1.468-4.116,5.107-6.829,4.569-6.829,4.569.742.943,2.785,1.016,2.785,1.016-3.126,1.122-4.286-.983-4.286-.983.046,4.622,5.115,7.25,7.182,6.8a7.862,7.862,0,0,1-3.484,1.251s8.987,7.059,25.109-6.849A10.732,10.732,0,0,0,597,72.032l1.723,4.818",
    transform: "translate(-541.16 -53.352)",
    fill: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Model_1",
    "data-name": "Model 1",
    transform: "translate(465.427 57.825)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 5.63,
    transform: "translate(32.298 116.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M496.016,110.055l4.72,59.347s-1.463,2.712,8.152,2.723c15.747.021,23.193-.929,5.578-3.687l-4.077-1.041,7.471-61.955Z",
    transform: "translate(-429.387 -17.741)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M495.16,80.836l6.849-11.87L510.3,74.9l-1.3,10.683-6.276,17.324L491.14,97.722Z",
    transform: "translate(-432.24 -39.079)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M453.983,142.675s10.711,63.094,10.916,68.442S469.63,272,469.63,272l41.341,2.057s9.049-42.574,8.842-58.823-6.083-76.115-6.083-76.115l-33.4,4.336Z",
    transform: "translate(-453.975 1.956)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M516.9,76.687s-35.215-7.914-49.459,32.446-13.453,64.494-13.453,70.428S513.733,176,513.733,176s-4.352-20.582-2.374-28.493c1.789-7.15,7.457-22.066,8.529-24.862a.091.091,0,0,1,.176.036v5.912a.159.159,0,0,0,.187.157l22.367-4.189s6.725-32.444-11.871-43.127C530.746,81.435,518.481,102.8,516.9,76.687Z",
    transform: "translate(-453.978 -34.93)",
    fill: "#0555e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M471.263,107.5l7.148,67.244a4.241,4.241,0,0,0,3.122,3.649,40.216,40.216,0,0,0,9.3,1.089c23.808.534,26.4-3.623,7.95-4.294l-4.5-.946a2.292,2.292,0,0,1-1.815-2.395l3.855-66.771Z",
    transform: "translate(-443.867 -17.955)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M473.722,91.671s-2.734,16.931-2.769,24.133a.124.124,0,0,0,.139.122l25.218-2.389a.48.48,0,0,0,.433-.433l1.907-19.455",
    transform: "translate(-444.048 -25.797)",
    fill: "#0555e6",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M479.937,158.565s7.5,38.451,4.715,60.71-4.571,42.331-4.571,42.331",
    transform: "translate(-438.793 13.333)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M481.166,223.05s-1.287,8.79-.656,9.294a20.964,20.964,0,0,1,2.2,3.256l-1.514,4.327-8.706,1-6.595-7.09v-10.2Z",
    transform: "translate(-447.01 51.054)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M478.277,223.916V235l5.059,7.406.17.3,9.462-1.084,1.647-5.636s-2.067-1.686-3.129-2.414c-.109-.074,1.515-.141,1.45-.192-.352-.282-.766-2.945-.249-5.465a15.583,15.583,0,0,0,.179-4.639Z",
    transform: "translate(-439.764 51.187)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M504.227,221.681l-.45,4.5a1.277,1.277,0,0,1-1.281,1.149l-28.195-.235a1.277,1.277,0,0,1-1.266-1.244l-.132-5.226a1.278,1.278,0,0,1,1.319-1.309l28.778.965A1.276,1.276,0,0,1,504.227,221.681Z",
    transform: "translate(-442.908 48.868)",
    fill: "#0555e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M492.655,220.131a1.259,1.259,0,0,1,1.136,1.4l-.414,5.26a1.345,1.345,0,0,1-.325.781,1.156,1.156,0,0,1-.9.407l-29.7-.634a1.24,1.24,0,0,1-1.168-1.235l-.238-6.089a1.254,1.254,0,0,1,1.255-1.352",
    transform: "translate(-449.842 48.491)",
    fill: "#0555e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M480.057,219.563l1.479.044a1.259,1.259,0,0,1,1.136,1.4l-.414,5.261a1.345,1.345,0,0,1-.325.781",
    transform: "translate(-438.723 49.015)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M493.978,226.706c-1.563,2.552-8.719,6.438-14.59,2.553-.311-.25-.7-.032-.778.461-.456,2.834-1.1,6.6-1.617,9.568a52.964,52.964,0,0,0-.766,9.985h0l42.64-.747h0c-.057-3.263-1.758-6-4.016-6.517-5.557-1.279-15.052-4.032-19.958-15.17C494.686,226.368,494.232,226.29,493.978,226.706Z",
    transform: "translate(-440.967 53.035)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M481.618,227.321c-1.666,2.553-9.158,5.964-15.187,2.265-.331-.25-.745-.032-.831.463-.488,2.834-1.178,6.6-1.731,9.57a49.913,49.913,0,0,0-.827,9.987h0l45.385-.8h0c0-.108-.006-.216-.013-.323-.166-3.119-1.932-5.69-4.256-6.189-4.756-1.024-13.112-3.509-18.374-9.668a19.465,19.465,0,0,1-3.191-5.173C482.372,226.983,481.889,226.905,481.618,227.321Z",
    transform: "translate(-448.68 53.395)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M500.018,246.428c-.166-3.119-1.932-5.69-4.256-6.189-4.756-1.024-13.112-3.509-18.375-9.668",
    transform: "translate(-440.284 55.453)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M501.19,62.95A61.739,61.739,0,0,0,496.714,75.2a12.26,12.26,0,0,0,1.381,9.207l.3.506a8.839,8.839,0,0,0,8.451,4.283h0a12.251,12.251,0,0,0,8.632-4.817,90.361,90.361,0,0,0,6.849-11.033s6.82-11.385-4.693-16.761S501.19,62.95,501.19,62.95Z",
    transform: "translate(-429.187 -47.145)",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M500.616,72.539l-.057.117a2.436,2.436,0,0,1-3.29,1.146l-.017-.01.066-2.1a22.373,22.373,0,0,1,.173-2.915c.349-3.894.032-5.707,1.29-8.291,3.327-6.836,7.147-4.435,7.147-4.435a4.275,4.275,0,0,1,.453-.533c8.117-9.431,16.024-4.688,20.7.415a14.437,14.437,0,0,1,1.831,2.208c.422.564.8,1.108,1.117,1.607,3.565,5.563,6.341,5.321,6.341,5.321-.846.864-2.9.715-2.9.715,3.008,1.463,4.4-.518,4.4-.518-.548,4.623-5.91,6.7-7.931,6.028a7.923,7.923,0,0,0,3.352,1.633s-9.768,6.089-24.4-9.594a10.807,10.807,0,0,1-5.852,4.214l-2.251,4.636",
    transform: "translate(-428.665 -50.109)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 2.531,
    y2: 10.215,
    transform: "translate(65.966 77.443)",
    fill: "#9bcaa7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tables",
    transform: "translate(434.406 212.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M549.2,158.923H438.765a4.358,4.358,0,0,1-4.359-4.359",
    transform: "translate(-434.406 -143.45)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 13.642,
    height: 136.628,
    transform: "translate(148.281 12.894)",
    fill: "#f6f7f7",
    stroke: "#494848",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 13.855,
    height: 133.861,
    transform: "translate(334.038 12.894)",
    fill: "#f6f7f7",
    stroke: "#494848",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M799.25,163.024H437.409c-1.659,0-3-1.951-3-4.359v-6.757c0-2.406,1.344-4.357,3-4.357H799.25c1.657,0,3,1.951,3,4.357v6.757C802.251,161.073,800.907,163.024,799.25,163.024Z",
    transform: "translate(-434.406 -147.552)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    d: "M10.387,0H43.373A10.387,10.387,0,0,1,53.759,10.387v6.076a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10.387A10.387,10.387,0,0,1,10.387,0Z",
    transform: "translate(314.086 136.269)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 88.607,
    y2: 0.241,
    transform: "translate(277.407 15.231)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M462.05,147.552H783.2c1.591,0,2.88,2.3,2.88,5.137",
    transform: "translate(-418.235 -147.552)",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    d: "M11.114,0h31.53A11.114,11.114,0,0,1,53.759,11.114v6.5a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v-6.5A11.114,11.114,0,0,1,11.114,0Z",
    transform: "translate(128.222 134.712)",
    fill: "#f6f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Projects",
    transform: "translate(654.987 188.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(4.213 17.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    d: "M0,0H64.694a1.872,1.872,0,0,1,1.872,1.872v2.19a1.872,1.872,0,0,1-1.872,1.872H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    d: "M0,0H48.369a1.159,1.159,0,0,1,1.159,1.159V2.514a1.159,1.159,0,0,1-1.159,1.159H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 1.131)",
    fill: "#f6f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 11.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    d: "M0,0H64.694a1.872,1.872,0,0,1,1.872,1.872v2.19a1.872,1.872,0,0,1-1.872,1.872H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    d: "M0,0H48.253a1.159,1.159,0,0,1,1.159,1.159V2.514a1.159,1.159,0,0,1-1.159,1.159H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0.116 1.131)",
    fill: "#f6f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(2.673 5.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    d: "M0,0H64.694a1.872,1.872,0,0,1,1.872,1.872v2.19a1.872,1.872,0,0,1-1.872,1.872H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    d: "M0,0H48.369a1.159,1.159,0,0,1,1.159,1.159V2.514a1.159,1.159,0,0,1-1.159,1.159H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 1.131)",
    fill: "#f6f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(4.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    d: "M0,0H64.694a1.872,1.872,0,0,1,1.872,1.872v2.19a1.872,1.872,0,0,1-1.872,1.872H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    d: "M0,0H48.369a1.159,1.159,0,0,1,1.159,1.159V2.514a1.159,1.159,0,0,1-1.159,1.159H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 1.131)",
    fill: "#f6f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Projects-2",
    "data-name": "Projects",
    transform: "translate(494.76 200.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0 5.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    d: "M0,0H64.694a1.872,1.872,0,0,1,1.872,1.872v2.19a1.872,1.872,0,0,1-1.872,1.872H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    d: "M0,0H48.369a1.159,1.159,0,0,1,1.159,1.159V2.514a1.159,1.159,0,0,1-1.159,1.159H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 1.131)",
    fill: "#f6f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(2.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    d: "M0,0H64.694a1.872,1.872,0,0,1,1.872,1.872v2.19a1.872,1.872,0,0,1-1.872,1.872H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    d: "M0,0H48.369a1.159,1.159,0,0,1,1.159,1.159V2.514a1.159,1.159,0,0,1-1.159,1.159H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 1.131)",
    fill: "#f6f7f7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin3);
export default __webpack_public_path__ + "static/media/login-3.a4656cf3c60a162849d50c4888beb339.svg";
export { ForwardRef as ReactComponent };